<template>
  <div class="details">
    <div class="details_wrap">
      <div class="cover">
        <img :src="colInfo.colThumbnailUrl"
             alt="" />

        <!-- <i-player :videoinfo="colInfo"
                  v-on:endValue="end"
                  v-on:ok="ok">
        </i-player> -->
      </div>
      <div class="title">
        <p>{{colInfo.colTitle}}</p>
        <div v-if="colInfo.entity"
             style="color:#999999">
          {{getTimes(colInfo.colCreateDt)}}
          <div class="img_text">
            <img src="../../assets/images/sc.png"
                 alt
                 v-if="colInfo.colIsCollect==1"
                 @click="collectMeet(1)" />
            <img src="../../assets/images/unsc.png"
                 v-if="colInfo.colIsCollect==0||!colInfo.colIsCollect"
                 @click="collectMeet(0)"
                 alt />
            <span>{{texts}}</span>
          </div>
          <span class="colOrder">参会人数：{{colInfo.orderNum?colInfo.orderNum:0}}</span>
        </div>
      </div>
      <ul class="tabmenus">
        <li v-for="(item,index) in menulist"
            @click="tablist(index)"
            :class="{'active':active==index}"
            :key="index">
          <span>{{item.name}}</span>
        </li>
      </ul>
    </div>
    <div class="box">
      <!--课程介绍-->
      <div v-if="active==0">
        <i-course v-if="colInfo.colDesc!=undefined&&(colInfo.colDesc!=null&&colInfo.colDesc!='')"
                  :value="colInfo.colDesc"></i-course>
      </div>
      <div v-if="active==1"
           class="slideT">
        <div class="titles">
          <i class="titleIcon"></i>
          <span>单课</span>
        </div>
        <div>
          <div class="item"
               v-for="(item,index) in relList"
               :key="index"
               @click="lookV(item)">
            <div>
              <span>{{item.title}}</span>
              <!-- <span class="itemTR"
                    v-if="item.cvrelTrySee==1">上次看到</span> -->
            </div>
            <div class="itemB">
              <!-- <span v-if="item.cvrelTrySee==1">
                <i class="shikanIcon"></i>
                <span class="colorY"
                      v-if="item.cvrelSeeTime!=0">试看{{item.cvrelSeeTime}}分钟</span>
                <span class="colorY"
                      v-else>试看</span>
              </span> -->
              <span>{{getTimes(item.sDt)}}</span>
              <span>{{item.viewCount}}次学习</span>
              <!-- <i class="itemB-code"
                 v-if="item.cvrelTrySee == 0"></i> -->
            </div>
          </div>
        </div>

        <div class="noMore">
          <span>没有更多了...</span>
        </div>
        <div class="slideTB"
             @click="subscribe"
             v-if="isCharge">
          <!--我要参会-->
          <div v-if="isfree==0">
            <span>参加会议</span>
            <span>¥{{currentPrice}}</span>
            <span>（有效期半年可看）</span>
          </div>
          <!--免费参与-->
          <div v-if="isfree==1">
            <span>免费参与</span>
          </div>
          <!--会员免费-->
          <div v-if="isfree==2">
            <span>会员免费</span>
          </div>
        </div>

        <div class="slideTB"
             v-if="!isCharge">
        <!--已购买-->
          <div v-if="isfree==3">
            <span>已购买</span>
          </div>
        </div>
      </div>

      <div class="container"
           v-if="active==2">
        <template v-if="columnList.length>0">
          <div class="container_item"
               v-for="(item) in columnList"
               :key="item.relId"
               @click="toDetails(item.colId,item.type)">
            <!-- <p class="item_title">
              <span class="title_name">
                <span>{{item.colTitle}}</span>
              </span>
              <span class="title_time">{{getTimes(item.colCreateDt)}}</span>
            </p> -->
            <div class="con">
              <img class="con_images"
                   :src="item.colThumbnailUrl"
                   alt
                   v-if="item.colThumbnailUrl" />
              <img class="con_images"
                   src="../../assets/images/default.png"
                   alt
                   v-else />
              <div class="con_right">
                <p class="con_title">{{item.colTitle}}</p>
                <p class="con_org">{{getTimes(item.colCreateDt)}}</p>
              </div>
            </div>
          </div>
        </template>
        <img src="../../assets/images/nothing.png"
             alt
             v-else
             class="nothing" />
      </div>
    </div>
  </div>
</template>
<script>

import iCourse from "../container/course";
import weui from "weui.js";
import loginService from "../../plugin/extendFn/loginService";
import AppSetting from '../../AppSetting';
export default {
  data () {
    return {
      isVipBuy:0,
      isfree:0,
      columnList: [],
      texts: "收藏",
      ra_wxUser: null,
      active: 0,
      coldata: {},
      colInfo: {},
      permissionsType: "",
      originalPrice: "",
      currentPrice: "",
      relList: [],
      menulist: [
        { name: "会议简介" },
        { name: "课程目录" },
        { name: "相关会议" }
      ]
    };
  },
  props: {},
  methods: {
    getTimes (value) {
      let val = new Date(value).getTime();
      return new Date(val).Format("yyyy.MM.dd hh:mm");
    },
    tablist (type) {
      this.active = type;
    },
    end (val) {
      // this.list[2].name = val;
      // this.ppt = val;
    },
    ok (val) {
      if (val == "success") {
        if (this.rightanswer.length < 1) {
          //没有题目
          this.isQuestion = false;
        } else {
          //有题目 是否答题  是否领取证书
          if (this.videoData.vIsComplete == 0) {
            //未答题
            // bus.$emit('isstop','stop')
            this.isQuestion = true;
          } else if (this.videoData.vIsComplete == 1) {
            //已答题
            if (this.videoData.vIsCredential == 0) {
              //未领取证书
              // bus.$emit('isstop','stop')
              this.issuccessinfo = true;
            } else {
            }
          }
        }
      }
    },
    lookV (res) {
      // 课程收费

      if (this.isCharge) {
        this.topTips("需参加会议后才能观看");
      } else {
        //this.coldata = res;
        if (res.type == '1') {
          this.$router.push({
            name: "Details",
            query: { type: "live", liveId: res.relId }
          });

        } else {
          this.$router.push({
            name: "vDetails",
            query: { type: "video", videoId: res.relId }
          });
        }

      }
    },
    onBridgeReady (params) {
      console.log(params)
      var that = this;
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: params.appId, //公众号名称，由商户传入
          timeStamp: params.timeStamp + "", //支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          nonceStr: params.nonceStr, //支付签名随机串，不长于 32 位
          package: params.package, //统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          signType: "MD5", //签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          paySign: params.sign //支付签名
        },
        function (res) {
          if (res.err_msg === "get_brand_wcpay_request:ok") {
            that.buyed = true
            that.colInfo.buyed = true
            //that.$router.push({ path: "/myOrder" });
          } else if (res.err_msg === "get_brand_wcpay_request:fail") {
            // this.alert("支付失败！");
          }
        }
      );
    },
    login () {
      loginService.login(this.$router)
      .then(loginUser=>{
        this.ra_wxUser=loginUser
      })
    },
    subscribe () {
      if (!this.ra_wxUser) {
        this.login();
        return
      }

      let param = {
        orderType: 3, //vip购买，1 视频购买，2直播购买，3会议购买
        bId: this.colInfo.colId,
        originalPrice: this.originalPrice,
        payPrice: this.currentPrice,
        uid: this.ra_wxUser ? this.ra_wxUser.uId : '',
        isVipBuy:this.isVipBuy,
      };

      this.$postHttp(AppSetting.baseUrl + "/order/app/add", param).then(res => {
        if (res.data.code == 0) {
          if (this.currentPrice <= 0) {
            this.buyed = true
            this.colInfo.buyed = true
            this.$toast.success('购买成功')
            return
          }
          const pay_params = JSON.parse(res.data.parMap);

          if (typeof WeixinJSBridge === "undefined") {

            if (document.addEventListener) {
              document.addEventListener(
                "WeixinJSBridgeReady",
                this.onBridgeReady,
                false
              );
            } else if (document.attachEvent) {
              document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
              document.attachEvent("onWeixinJSBridgeReady", this.onBridgeReady);
            }
          } else {
            console.log('走这里2')
            this.onBridgeReady(pay_params);
          }
        } else if (res.data.code == 2) {
          this.toast('购买成功')
        } else {
          this.confirm('授权失败，点击确定微信授权', '取消', '确定', () => {
            return true
          }, () => {
            this.login();
            return true;
          })
        }
      });
    },
    async collectMeet (type) {
      this.ra_wxUser = await loginService.getLoginUser();
      if (!this.ra_wxUser) {
        this.login();
      } else if (this.ra_wxUser) {
        if (type == 0) {
          this.$postHttp(AppSetting.baseUrl + "/column/collection", {
            uid: this.ra_wxUser ? this.ra_wxUser.uId : '',
            id: this.colInfo.colId
          }).then(res => {
            // bus.$emit('isstop','stop')
            if (res.data.code == 0) {
              this.texts = "已收藏";
              this.colInfo.colIsCollect = 1;
              this.toast("收藏成功");
            } else {
              this.topTips("收藏失败");
            }
          });
        } else {
          // bus.$emit('isstop','stop')
          weui.dialog({
            content: "确定要取消收藏吗？",
            className: "yors",
            buttons: [
              {
                label: "取消",
                type: "default",
                onClick: res => { }
              },
              {
                label: "确定",
                type: "primary",
                onClick: () => {
                  this.$postHttp(AppSetting.baseUrl + "/column/collection/cancel", {
                    uid: this.ra_wxUser ? this.ra_wxUser.uId : '',
                    id: this.colInfo.colId
                  }).then(res => {
                    if (res.data.code == 0) {
                      this.texts = "收藏";
                      this.colInfo.colIsCollect = 0;
                      this.toast("取消收藏成功");
                    } else {
                      this.topTips("取消收藏失败");
                    }
                  });
                }
              }
            ]
          });
        }
      }
    },
    toDetails (id, type) {

      this.$router.push({
        name: "colDetails",
        query: { type: "column", colId: id }
      });
      // window.location.reload()

    },
    listdata (id) {
      let uGenre = this.ra_wxUser ? this.ra_wxUser.uGenre : 1;
      this.$postHttp(AppSetting.baseUrl + "/column/info", {
        id: id,
        uid: this.ra_wxUser ? this.ra_wxUser.uId : ''
      }).then(res => {
        if (res.data.code == 0) {
          let colId = this.$route.query.colId
          this.colInfo = res.data.data;
          if (this.colInfo.colIsCollect == 1) {
            this.texts = '已收藏'
          }

          document.title = res.data.data.colTitle;
          this.columnList = res.data.relatedList.filter(v => v.colId != colId);
          this.currentPrice = res.data.data.colFees;
          this.isVipBuy = res.data.isfree;
        }
      });
      this.$postHttp(AppSetting.baseUrl + "/column/rel/list", {
        id: id,
        uid: this.ra_wxUser ? this.ra_wxUser.uId : ''
      }).then(res => {
        if (res.data.code == 0) {
          this.relList = res.data.list;
        }
      });
    }
  },
  components: {
    iCourse

  },
  computed: {
    // isCharge () {
    //   let status = false
    //   if (!this.colInfo.buyed) {
    //     status = true
    //   }

    //   return status
    // }
    isCharge () {
            let status = true;
                if(this.colInfo.buyed){
                  this.isfree = 3;
                  status = false
                }else if(this.colInfo.colIsCharge == 0){//0免费
                  this.isfree = 1;
                  this.currentPrice = "0";
                  //status = false
                }else if(this.isVipBuy == "1"){//会员免费
                  this.isfree = 2;
                  this.currentPrice = "0";
                  //status = false
                }

                console.log(this.isfree)
            return status
          }
  },
  async mounted () {
    this.ra_wxUser = await loginService.getLoginUser()
    this.listdata(this.$route.query.colId);
  }
};
</script>
<style scoped lang="scss">
.details {
  display: flex;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  flex-direction: column;
  .details_wrap {
    /*height: 6.42rem;*/
    flex-grow: 0;
    z-index: 1;
  }
}
.nothing {
  width: 100%;
  display: inline-block;
}
.cover {
  height: 4.21rem;
  width: 100vw;
  img {
    width: 100%;
    height: 100%;
  }
}
.colOrder {
  margin-right: 10px;
  float: right;
  color: #666666;
}
.img_text {
  float: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  // width: 1.8rem;
  float: right;
  img {
    width: 0.38rem;
    height: 0.38rem;
    margin-right: 0.09rem;
    position: relative;
    top: -0.03rem;
  }
  font-size: 0.28rem;
  color: #666666;
}
.box {
  background: #ffffff;
  /*min-height: 5.4rem;*/
  flex-grow: 1;
  width: 100vw;
  height: 100%;
  overflow-y: scroll;
  position: relative;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
  display: flex;
}
.slideT {
  height: 100%;
  overflow: auto;
  font-size: 0.28rem;
  color: #666666;
  width: 100%;
  padding: 0.3rem;
  box-sizing: border-box;
  .titles {
    color: #1192ff;
    font-weight: 800;
    border-bottom: 0.01rem solid #eeeeee;
    padding-bottom: 0.3rem;
    // margin-bottom: 0.3rem;
  }
  .titleIcon {
    display: inline-block;
    width: 3px;
    height: 0.33rem;
    background: #1293ff;
    position: relative;
    top: 0.05rem;
  }
  .item {
    border-bottom: 0.01rem solid #eeeeee;
    padding-bottom: 0.3rem;
    padding-top: 0.3rem;
  }
  .itemTR {
    float: right;
    font-size: 0.22rem;
    color: #fff;
    background: #f5b53a;
    padding: 0.07rem 0.16rem;
  }

  .itemB {
    font-size: 0.24rem;
    color: #999999;
    margin-top: 0.19rem;
    position: relative;
    display: flex;
    justify-content: space-between;
  }

  .itemB-code {
    display: inline-block;
    width: 0.28rem;
    height: 0.3rem;
    background: url("../../assets/images/code.png") no-repeat;
    background-size: 100% 100%;
    position: absolute;
    right: 0px;
    top: 50%;
    margin-top: -0.15rem;
  }
  .shikanIcon {
    display: inline-block;
    width: 0.24rem;
    height: 0.24rem;
    background: url("../../assets/images/shikan.png") no-repeat;
    background-size: 100% 100%;
    vertical-align: middle;
  }
  .colorY {
    color: #f5b53a;
  }
  .noMore {
    font-size: 0.24rem;
    color: #cccccc;
    text-align: center;
    padding: 0.2rem 0px;
  }
  .slideTB {
    width: 100%;
    font-size: 0.3rem;
    color: #fff;
    text-align: center;
    line-height: 0.9rem;
    background: #05a2ff;
    position: absolute;
    bottom: 0px;
    left: 0px;
  }
}
.container {
  margin-bottom: 0.98rem;
  .container_item {
    background: #ffffff;

    padding-left: 0.3rem;
    box-sizing: border-box;
    border-bottom: 1px solid #e6e6e6;
    .item_title {
      padding-right: 0.29rem;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      padding-top: 0.16rem;
      padding-bottom: 0.21rem;
      .title_name {
        font-size: 0.26rem;
        color: #666666;
      }
      .title_time {
        font-size: 0.24rem;
        color: #999999;
      }
    }

    .con {
      /*border-bottom: 1px solid #E6E6E6;*/
      // box-sizing: border-box;

      padding: 0.2rem 0 0.16rem;
      height: 1.77rem;
      display: flex;
      align-items: flex-start;
      flex-shrink: 0;
      .con_right {
        height: 1.62rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      .con_images {
        width: 2.84rem;
        height: 1.6rem;
        margin-right: 0.22rem;
        border: 1px solid #e6e6e6;
      }
      .con_title {
        width: 3.83rem;
        font-size: 0.26rem;
        color: #333333;
        line-height: 0.42rem;
        display: -webkit-box;
        -webkit-box-orient: vertical; /*设置弹性盒模型子元素的排列方式*/
        -webkit-line-clamp: 2; /*限制文本行数*/
        font-weight: bold;
        /*white-space: nowrap;      !*超出的空白区域不换行*!*/
        overflow: hidden; /*超出隐藏*/
        text-overflow: ellipsis; /*文本超出显示省略号*/

        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        /* autoprefixer: off */
        -webkit-box-orient: vertical;
        /* autoprefixer: on */
        -webkit-line-clamp: 2;
      }
    }
    .con_org {
      font-size: 0.26rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 3.83rem;
    }
  }
}
.title {
  width: 100%;
  font-size: 0.28rem;
  line-height: 0.5rem;
  box-sizing: border-box;
  padding: 0.15rem 0.25rem 0.2rem 0.29rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  p:nth-of-type(1) {
    color: #333333;
    font-size: 0.34rem;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.tabmenus {
  display: flex;
  width: 7.5rem;
  height: 0.8rem;
  background: #ffffff;
  border-top: 1px solid #e6e6e6;
  border-bottom: 1px solid #e6e6e6;
  font-size: 0.28rem;
  color: #666666;
  align-items: center;
  z-index: 1;
  li {
    /*width: 2.46rem;*/
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  li:nth-of-type(2) > span {
    display: inline-block;
    width: 100%;
    line-height: 0.3rem;
    text-align: center;
    border-left: 1px solid #e6e6e6;
    border-right: 1px solid #e6e6e6;
  }
  .active {
    color: #ff781b;
    border-bottom: 1px solid #ff781b;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/column/colDetails.vue